import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "searchPeopleFilled"
const SearchPeopleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.25 12.375C19.942 12.375 22.125 14.558 22.125 17.25 22.125 18.325 21.775 19.319 21.186 20.125L23.406 22.345 22.345 23.405 20.125 21.185C19.32 21.775 18.325 22.125 17.25 22.125 14.558 22.125 12.375 19.942 12.375 17.25S14.558 12.375 17.25 12.375M17.25 13.875C15.386 13.875 13.875 15.386 13.875 17.25S15.386 20.625 17.25 20.625 20.625 19.114 20.625 17.25 19.114 13.875 17.25 13.875"
            clipRule="evenodd"
          />
          <path d="M10.5 13.125C11.144 13.125 11.743 13.165 12.298 13.235 11.408 14.333 10.875 15.729 10.875 17.25 10.875 18.49 11.23 19.646 11.842 20.625H1.5S1.5 13.125 10.5 13.125M10.875 1.5C13.567 1.5 15.75 3.683 15.75 6.375S13.567 11.25 10.875 11.25 6 9.067 6 6.375 8.183 1.5 10.875 1.5" />
        </svg>
      }
    </span>
  )
}
export default SearchPeopleFilledIcon
